import { ANDAR_BAHAR_BET_TYPES } from '@ezugi/constants/src/betTypes/andarbahar';

const {
  ANDAR,
  BAHAR,
  ONE_TO_FIVE,
  SIX_TO_TEN,
  ELEVEN_TO_FIFTEEN,
  SIXTEEN_TO_TWENTYFIVE,
  TWENTYSIX_TO_THIRTY,
  THIRTYONE_TO_THIRTYFIVE,
  THIRTYSIX_TO_FORTY,
  FORTYONE_OR_MORE,
} = ANDAR_BAHAR_BET_TYPES;

export {
  ANDAR,
  BAHAR,
  ONE_TO_FIVE,
  SIX_TO_TEN,
  ELEVEN_TO_FIFTEEN,
  SIXTEEN_TO_TWENTYFIVE,
  TWENTYSIX_TO_THIRTY,
  THIRTYONE_TO_THIRTYFIVE,
  THIRTYSIX_TO_FORTY,
  FORTYONE_OR_MORE,
};

export const OTT_ANDARBAHAR_BET_TYPES = {
  ANDAR_FIRST: 'AndarFirstBet',
  ANDAR_SECOND: 'AndarSecondBet',
  BAHAR_FIRST: 'BaharFirstBet',
  BAHAR_SECOND: 'BaharSecondBet',
};

export const MAIN_BETS = {
  ANDAR,
  BAHAR,
  ...OTT_ANDARBAHAR_BET_TYPES,
};

export const SIDEBETS = {
  ONE_TO_FIVE,
  SIX_TO_TEN,
  ELEVEN_TO_FIFTEEN,
  SIXTEEN_TO_TWENTYFIVE,
  TWENTYSIX_TO_THIRTY,
  THIRTYONE_TO_THIRTYFIVE,
  THIRTYSIX_TO_FORTY,
  FORTYONE_OR_MORE,
};

export const SIDEBETS_LIST: string[] = [
  ONE_TO_FIVE,
  SIX_TO_TEN,
  ELEVEN_TO_FIFTEEN,
  SIXTEEN_TO_TWENTYFIVE,
  TWENTYSIX_TO_THIRTY,
  THIRTYONE_TO_THIRTYFIVE,
  THIRTYSIX_TO_FORTY,
  FORTYONE_OR_MORE,
];

/** difference between the index position of a OTTAB sidebet in `SIDEBETS_LIST` and the key of its payout in payouts object from state */
export const OTT_SIDEBET_TO_PAYOUT_INDEX_ADJUSTMENT = 5;

/** difference between the index position of a AB/UAB sidebet in `SIDEBETS_LIST` and the key of its payout in payouts object from state */
export const SIDEBET_TO_PAYOUT_INDEX_ADJUSTMENT = 3;

export const SIDEBETS_WINNERS : Record<string, number[]> = {
  [ONE_TO_FIVE]: [ 1, 5 ],
  [SIX_TO_TEN]: [ 6, 10 ],
  [ELEVEN_TO_FIFTEEN]: [ 11, 15 ],
  [SIXTEEN_TO_TWENTYFIVE]: [ 16, 25 ],
  [TWENTYSIX_TO_THIRTY]: [ 26, 30 ],
  [THIRTYONE_TO_THIRTYFIVE]: [ 31, 35 ],
  [THIRTYSIX_TO_FORTY]: [ 36, 40 ],
  [FORTYONE_OR_MORE]: [ 41, 51 ],
};

export default {
  ANDAR,
  BAHAR,
  ONE_TO_FIVE,
  SIX_TO_TEN,
  ELEVEN_TO_FIFTEEN,
  SIXTEEN_TO_TWENTYFIVE,
  TWENTYSIX_TO_THIRTY,
  THIRTYONE_TO_THIRTYFIVE,
  THIRTYSIX_TO_FORTY,
  FORTYONE_OR_MORE,
  ...OTT_ANDARBAHAR_BET_TYPES,
};
